import {lazy} from 'react';
import GenericFallbackSuspense from '../../../ui/GenericFallback/GenericFallbackSuspense';

const ModeOverlayBody = lazy(() => import('./ModeOverlayBody'/* webpackChunkName: 'ModeOverlayBody' */));

export default function ModeOverlayLazyLoader() {
  return (
    <GenericFallbackSuspense>
      <ModeOverlayBody />
    </GenericFallbackSuspense>
  );
}
